// extracted by mini-css-extract-plugin
module.exports = {"PriceSelector":"PriceSelector_PriceSelector__15gZb","innerPriceSelector":"PriceSelector_innerPriceSelector__2mj6J","error":"PriceSelector_error__1me49"};